<template>
  <About></About>
</template>

<script>
// @ is an alias to /src
import About from '@/components/About.vue'

export default {
  name: 'AboutView',
  components: {
    About
  }
}
</script>
